// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The EmissionPoint status
 */
export type EntryStatus = 'in_progress' | 'completed' | 'in_review' | 'reviewed' | 'rejected' | 'approved' | 'submitted' | 'submission_error';

export const EntryStatus = {
    in_progress: 'in_progress' as EntryStatus,
    completed: 'completed' as EntryStatus,
    in_review: 'in_review' as EntryStatus,
    reviewed: 'reviewed' as EntryStatus,
    rejected: 'rejected' as EntryStatus,
    approved: 'approved' as EntryStatus,
    submitted: 'submitted' as EntryStatus,
    submission_error: 'submission_error' as EntryStatus
};

